<template>
  <div
    class="hint-sign"
    :class="{
      'hint-sign--hovered': hovered,
    }"
    v-on="$listeners"
  >
    <svg :width="frameSize" :height="frameSize">
      <circle
        class="hint-sign__bar"
        :class="{
          'hint-sign__bar--open': isOpen,
        }"
        :style="barStyle"
        :stroke-width="strokeWidth"
        :r="radiusConsideringStrokeWidth"
        :cx="radius"
        :cy="radius"
      />
      <text
        class="hint-sign__question-mark"
        :x="radius"
        :y="radius * 1.5"
        text-anchor="middle"
      >
        ?
      </text>
    </svg>
  </div>
</template>

<script>
const RETURN_TIMEOUT_IN_SECONDS = 0.5;

export default {
  props: {
    radius: {
      type: Number,
      required: true,
    },
    strokeWidth: {
      type: Number,
      required: true,
    },
    delayInSeconds: {
      type: Number,
      required: true,
    },
    isOpen: {
      type: Boolean,
      required: true,
    },
    hovered: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    frameSize() {
      return this.radius * 2;
    },
    radiusConsideringStrokeWidth() {
      return this.radius - this.strokeWidth / 2;
    },
    barStyle() {
      const delay = this.hovered
        ? this.delayInSeconds
        : RETURN_TIMEOUT_IN_SECONDS;

      return {
        transition: `stroke-dashoffset ${delay}s, fill 0.2s`,
      };
    },
  },
};
</script>

<style lang="scss">
$hint-sign-color: #777;

.hint-sign {
  cursor: default;
  display: flex;

  &__bar {
    fill: $hint-sign-color;
    stroke: $lb-color-primary;
    stroke-dasharray: 44;
    stroke-dashoffset: 44;
    transform: rotate(-90deg);
    transform-origin: 50% 50%;

    &--open {
      fill: $lb-color-primary;
    }
  }

  &--hovered {
    .hint-sign__bar {
      stroke-dashoffset: 0;
    }
  }

  &__question-mark {
    fill: #fff;
    font-size: 0.7rem;
    pointer-events: none;
  }
}
</style>
